module Meevo.Plugins.PointPromotionCampaign {
    "use strict";

    export class PromotionsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Meevo.Model.IPointPromotionCampaign> {
        model: Meevo.Model.IPointPromotionCampaign;
        pointPromotionType: Meevo.Model.PointPromotionTypeEnum;
        specificItemTypeEnum = Meevo.Model.SpecificItemTypeEnum;
        pointPromotionTypeEnum = Meevo.Model.PointPromotionTypeEnum;

        public giftCardTypeList: any[];
        public membershipList: any[];
        public retailList: any[];
        public serviceList: any[];
        public packageList: any[];
        public serviceCategoryList: any[];

        public productCategories: any[];
        public manufacturers: any[];

        public subCategoryId: string = null;
        public manufacturerId: string = null;

        public promotions = [
            { value: Meevo.Model.PointPromotionTypeEnum.Birthday, label: 'LABEL_PROMO_BIRTHDAY' },
            { value: Meevo.Model.PointPromotionTypeEnum.ReferringAnotherClient, label: 'LABEL_PROMO_REFERRING_ANOTHER_CLIENT' },
            { value: Meevo.Model.PointPromotionTypeEnum.GiftCardPurchase, label: 'LABEL_PROMO_GIFT_CARD_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.GiftCardPurchaseTimesPurchasePrice, label: 'LABEL_PROMO_GIFT_CARD_PURCHASE_TIMES_PURCHASE_PRICE' },
            { value: Meevo.Model.PointPromotionTypeEnum.MembershipPurchase, label: 'LABEL_PROMO_MEMBERSHIP_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.PackagePurchase, label: 'LABEL_PROMO_PACKAGE_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.RebookingNextAppointmentFirst, label: 'LABEL_PROMO_REBOOKING_NEXT_APPOINTMENT_FIRST' },
            { value: Meevo.Model.PointPromotionTypeEnum.RebookingNextAppointmentAny, label: 'LABEL_PROMO_REBOOKING_NEXT_APPOINTMENT_ANY' },
            { value: Meevo.Model.PointPromotionTypeEnum.RetailPurchaseMinimumAmount, label: 'LABEL_PROMO_RETAIL_PURCHASE_MINIMUM_AMOUNT' },
            { value: Meevo.Model.PointPromotionTypeEnum.ServicePurchaseMinimumAmount, label: 'LABEL_PROMO_SERVICE_PURCHASE_MINIMUM_AMOUNT' },
            { value: Meevo.Model.PointPromotionTypeEnum.BookingAppointmentOnline, label: 'LABEL_PROMO_BOOKING_APPOINTMENT_ONLINE' },
            { value: Meevo.Model.PointPromotionTypeEnum.RetailPurchase, label: 'LABEL_PROMO_RETAIL_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.ServicePurchase, label: 'LABEL_PROMO_SERVICE_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.ServiceCategoryFirstTime, label: 'LABEL_PROMO_SERVICE_CATEGORY_PURCHASE' },
            { value: Meevo.Model.PointPromotionTypeEnum.ClientFirstVisit, label: 'LABEL_PROMO_CLIENT_FIRST_VISIT' },
            { value: Meevo.Model.PointPromotionTypeEnum.MembershipEFT, label: 'LABEL_PROMO_MEMBERSHIP_EFT' },
        ];

        eftPromoMembershipCriteria: any = {
            includeInactive: true,
            showInactiveFilter: true
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            sectionSecurityKey?: string
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                null,
                sectionSecurityKey);

            for (const promotion of this.promotions) {
                promotion.label = this.$translate.instant(promotion.label);
            }

            this.promotions.sort((a, b) => a.label.localeCompare(b.label));
        }

        private updateIsAll(promotion) {
            promotion.isAll = !promotion.isSpecificItem;
        }

        sectionModelRetrieved() {
            _(this.model.pointPromotions).each((promotion: Meevo.Model.IPointPromotion) => {
                switch (promotion.pointPromotionType) {
                    case Meevo.Model.PointPromotionTypeEnum.ReferringAnotherClient:
                        this.specificItemTypeChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.GiftCardPurchase:
                    case Meevo.Model.PointPromotionTypeEnum.GiftCardPurchaseTimesPurchasePrice:
                        this.giftCardSpecificItemChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.MembershipPurchase:
                        this.membershipSpecificItemChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.RetailPurchase:
                    case Meevo.Model.PointPromotionTypeEnum.RetailPurchaseMinimumAmount:
                        this.retailSpecificItemChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.ServicePurchase:
                    case Meevo.Model.PointPromotionTypeEnum.ServicePurchaseMinimumAmount:
                        this.serviceSpecificItemChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.PackagePurchase:
                        this.packageSpecificItemChanged(promotion);
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.ServiceCategoryFirstTime:
                        this.serviceCategorySpecificItemChanged(promotion);
                        break;
                    case Model.PointPromotionTypeEnum.MembershipEFT:
                        promotion.hideAllSelectedCheckbox = true;
                        break;
                }
                this.updateIsAll(promotion);
            });
        }

        specificItemTypeChanged(promotion: Meevo.Model.IPointPromotion, isSwitching: boolean = false) {
            if (isSwitching) {
                promotion.items.length = 0;
            }
            switch (promotion.specificItemType) {
                case Meevo.Model.SpecificItemTypeEnum.ServiceCategory:
                case Meevo.Model.SpecificItemTypeEnum.Service:
                    promotion.isSpecificItem = true;
                    break;
                default:
                    promotion.specificItemType = Meevo.Model.SpecificItemTypeEnum.Any;
                    promotion.isSpecificItem = false;
                    break;
            }
        }

        giftCardSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadGiftCardTypeList();
            }
            this.updateIsAll(promotion);
        }

        membershipSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadMembershipList();
            }
            this.updateIsAll(promotion);
        }

        membershipEftSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            this.updateIsAll(promotion);
        }

        serviceSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadServiceList();
            }
            this.updateIsAll(promotion);
        }

        serviceCategorySpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadServiceCategoryList();
            }
            this.updateIsAll(promotion);
        }

        retailSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadRetailList();
            }
            this.updateIsAll(promotion);
        }

        packageSpecificItemChanged(promotion: Meevo.Model.IPointPromotion) {
            if (promotion.isSpecificItem) {
                this.loadPackageList();
            }
            this.updateIsAll(promotion);
        }

        loadGiftCardTypeList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
                criteria: {
                    IncludeInvalid: false
                }
            }

            this.dataService.getListPaged("giftCardType", request).then((response) => {
                this.giftCardTypeList = response;
            });
        }

        loadMembershipList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
            }

            return this.dataService.getListPaged("membership", request).then((response: any) => {
                this.membershipList = response;
            });
        }

        loadServiceList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    excludePointPromotion: false,
                }
            }

            return this.dataService.getListPaged("service", request).then((response: any) => {
                this.serviceList = response;
            });
        }

        loadServiceCategoryList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
                sortDirection: Model.SortDirection.Ascending,
            }

            return this.dataService.getListPaged("ServiceCategory", request).then((response: any) => {
                this.serviceCategoryList = response;
            });
        }

        loadRetailList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    includeBundles: true,
                    includeProducts: true,
                    variantObjectState: [Model.ObjectStateEnum.Active, Model.ObjectStateEnum.Inactive],
                    excludePointPromotion: false,
                    includeNotForSale: false,
                }
            }

            return this.dataService.getListPaged("productVariant", request).then((response: any) => {
                this.retailList = response;

                this.generateFilters();
            });
        }

        loadPackageList() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 32768,
                sortDirection: Model.SortDirection.Ascending,
            }

            return this.dataService.getListPaged("packageType", request).then((response: any) => {
                this.packageList = response;
            });
        }

        private generateFilters() {
            this.subCategoryId = null;
            this.manufacturerId = null;

            this.productCategories = _.chain(this.retailList)
                .map(item => ({
                    id: item.subCategoryId,
                    displayName: `${item.category}: ${item.subCategory}`,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();

            this.manufacturers = _.chain(this.retailList)
                .map(item => ({
                    id: item.manufacturerId,
                    displayName: item.manufacturer,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();
        }

        filter(item: any): boolean {
            if (this.subCategoryId && item.subCategoryId !== this.subCategoryId) {
                return false;
            }

            if (this.manufacturerId && item.manufacturerId !== this.manufacturerId) {
                return false;
            }

            return true;
        }

        preSave(): void {
            _(this.model.pointPromotions).each((promotion: Meevo.Model.IPointPromotion) => {
                if (promotion.pointPromotionType !== Model.PointPromotionTypeEnum.MembershipEFT &&
                    promotion.pointPromotionType !== Model.PointPromotionTypeEnum.ReferringAnotherClient
                ) {
                    promotion.items = _(promotion.items).pluck('id');
                }

                if (promotion.pointPromotionType === Model.PointPromotionTypeEnum.ReferringAnotherClient
                ) {
                    this.updateIsAll(promotion);
                }

                switch (promotion.pointPromotionType) {
                    case Meevo.Model.PointPromotionTypeEnum.RebookingNextAppointmentFirst:
                        promotion.onlyFirstVisit = true;
                        break;
                    case Meevo.Model.PointPromotionTypeEnum.RebookingNextAppointmentAny:
                        promotion.onlyFirstVisit = false;
                        break;
                }
                promotion.isSpecificItem = !promotion.isAll;
                if (!promotion.isSpecificItem) {
                    promotion.items = [];
                }
            });
        }

        promotionAdd() {
            if (!this.pointPromotionType) {
                return;
            }

            const pointPromotionTypeExists = _(this.model.pointPromotions).any((item) => item.pointPromotionType === this.pointPromotionType);
            if (pointPromotionTypeExists) {
                return;
            }

            const promotion: Meevo.Model.IPointPromotion = {
                pointPromotion_TId: Guid.newSqlSequentialGuid().toString(),
                pointPromotionCampaign_TId: this.model.pointPromotionCampaignId,
                pointPromotionType: this.pointPromotionType,
                isAll: true,
                items: [],
            };

            switch (this.pointPromotionType) {
                case Model.PointPromotionTypeEnum.MembershipEFT:
                    promotion.hideAllSelectedCheckbox = true;
                    break;

                case Model.PointPromotionTypeEnum.ReferringAnotherClient:
                    promotion.specificItemType = Meevo.Model.SpecificItemTypeEnum.Any;
                    break;

                case Model.PointPromotionTypeEnum.Birthday:
                    promotion.specificItemType = Meevo.Model.SpecificItemTypeEnum.BirthMonth;
                    break;
            }

            this.model.pointPromotions.push(promotion);
        }

        promotionRemove(promotion: Meevo.Model.IPointPromotion) {
            this.model.pointPromotions = _(this.model.pointPromotions).difference([promotion]);
        }

        displayMembershipItem(item: any): string {
            if (!angular.isObject(item)) {
                return null;
            }

            return `${item.shortcut}: ${item.displayName}`;
        }

        displayRetailItem(item: any): string {
            if (!angular.isObject(item)) {
                return null;
            }

            const variantDisplayName = item.variantAttributes.length > 0 && item.variantAttributes[0].displayName.length > 0
                ? item.variantAttributes[0].displayName[0]
                : null;

            return (item.isDiscontinued ? `*${this.$translate.instant("LABEL_DISCONTINUED")} ` : '')
                + (item.sku ? `${item.sku}: ` : '')
                + item.displayName
                + (variantDisplayName ? `: ${variantDisplayName}` : '');
        }

        displayServiceItem(item: any): string {
            if (!angular.isObject(item)) {
                return null;
            }

            return `${item.shortcut}: ${item.displayName}`;
        }

        displayServiceCategoryItem(item: any): string {
            if (!angular.isObject(item)) {
                return null;
            }
            return item.displayName;
        }

        displayPackageItem(item: any): string {
            if (!angular.isObject(item)) {
                return null;
            }

            return item.displayName;
        }

        filterModal() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/pointPromotionCampaign/modal/products.filter.template.html",
                controller: "meevo.plugins.pointPromotionCampaign.ProductsFilterController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    context: this,
                }
            }

            this.modalService.showCustom(options);
        }
    }
}